export interface Option {
    id: string;
    title: string;
    value: string;
    hasCustomValue: boolean;
    category?: {
        id: string;
        title: string;
        displayOrder: number;
    };
    displayOrderWithInCategory: number;
    targetType?: string[];
}

export interface Options {
    options: Option[];
    customValue: string;
}

export const DEFAULT_FEEDBACK_OPTION = {
    options: [],
    customValue: '',
};
